import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Popover,
  OverlayTrigger,
  Glyphicon,
  Badge,
  Button
} from 'react-bootstrap';
import { fetchAuthorizedLabs } from 'actions/labs';
import { startPreloader, finishPreloader } from 'actions/preloader';
import { toTitleCase, concatStr } from 'helpers/StringHelper';

class TestLabs extends Component {
  componentDidMount() {
    this.props.startPreloader();
    this.props.fetchAuthorizedLabs().then(this.props.finishPreloader);
  }

  render() {
    const { labs } = this.props;

    if (!labs) return null;

    const sortedLabs = _.sortBy(labs, ['name']);

    return (
      <div>
        <h1>
          Authorized Test Labs <Badge>{labs.length}</Badge>
        </h1>
        <Table striped condensed hover>
          <thead>
            <tr>
              <th>Lab Name</th>
              <th>Country</th>
              <th>Testing Capability</th>
            </tr>
          </thead>
          <tbody>
            {_.map(sortedLabs, (lab, i) => {
              const { name, contactname, contactemail } = lab;
              const country = toTitleCase(lab.country);
              const shortName = concatStr(name);
              const popover = (
                <Popover
                  title={name}
                  style={{ marginLeft: 20 }}
                  id={`popover-lab-${i}`}
                >
                  <div style={{ fontSize: 12 }}>
                    <p>
                      <strong>Country:</strong> {country}
                    </p>
                    <p>
                      <strong>Contact Name:</strong> {contactname || 'n/a'}
                    </p>
                    <p>
                      <strong>Contact Email:</strong> {contactemail || 'n/a'}
                    </p>
                  </div>
                </Popover>
              );
              return (
                <tr key={i}>
                  <td>
                    <OverlayTrigger
                      trigger="click"
                      placement="right"
                      overlay={popover}
                      rootClose={true}
                    >
                      <Button bsStyle="link" bsSize="small">
                        {shortName} <Glyphicon glyph="info-sign" />
                      </Button>
                    </OverlayTrigger>
                  </td>
                  <td>{country}</td>
                  <td>WINNF-TS-0122</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

function mapStateToProps({ labs }) {
  return { labs };
}

export default connect(
  mapStateToProps,
  {
    fetchAuthorizedLabs,
    startPreloader,
    finishPreloader
  }
)(TestLabs);



// WEBPACK FOOTER //
// ./src/containers/Labs.js